import { defineComponent as _defineComponent } from 'vue';
import { VContainer, VRow, VCol } from "vuetify/lib";
import DemoSection from "@/components/DemoSection.vue";
import CodePreview from "@/components/CodePreview.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosTooltipDemo',
    setup(__props) {
        return { __sfc: true, VContainer, VRow, VCol, DemoSection, CodePreview };
    }
});
